import { Company } from '@/graphql/generated/types'

export interface CompanyState {
  loading?: boolean
  companies: Array<UICompanyModel>
  errorMessage?: string
}

export const state: CompanyState = {
  companies: [],
  loading: false
}

export type UICompanyModel = Company
